import { Component, ComponentInterface, Element, Prop } from '@stencil/core';

import { getRangeAges } from '../utils/get-range-ages';
import { uniAddProp } from '@uiwebkit/common';

@Component({ tag: 'uni-target-count' })
export class UniTargetCountComponent implements ComponentInterface {

  @Element() el!: HTMLElement;

  @Prop({ reflect: true }) range: number;

  @Prop({ reflect: true }) sex: boolean = false;

  @Prop() locations: string[];

  @Prop() ages: number[];

  @Prop({ reflect: true }) all: boolean = false;

  @Prop({ reflect: true }) selector: string;

  @Prop({ reflect: true }) prop: string;

  componentDidRender(): void {
    let count = 0;

    if (this.sex) {
      count = (count || 1) * 2;
    }

    if (this.locations?.length > 0) {
      count = (count || 1) * this.locations.length;
    }

    if (this.range > 0) {
      count = (count || 1) * getRangeAges(this.ages, this.range).length;
    }

    uniAddProp(this.el, this.prop, count, this.all, this.selector);
  }
}
